import React from 'react';
import styles from './styles.module.scss';

const Details = ({
  data: { sections = [], bottom_text: description = '' },
  className,
  forwardRef,
}) => {
  const renderList = ({ title = '', price = '' }, key) => (
    <li key={key} itemScope itemType='https://schema.org/ListItem'>
      {title && <div className={styles.title}>{title}</div>}
      {price && <div className={styles.text}>{price}</div>}
    </li>
  );

  return (
    <div
      className={`${styles.details} ${className}`}
      ref={forwardRef}
      data-testId='details-container'
      itemScope
      itemType='https://schema.org/ItemList'
    >
      <div className={styles.details__content}>
        {!!sections.length && <ul>{sections.map(renderList)}</ul>}
        {description && <div className={styles.description}>{description}</div>}
      </div>
    </div>
  );
};

export default Details;
